
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire34b5"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire34b5"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("6mvtm", function(module, exports) {
$parcel$export(module.exports, "RELAY_API_CONTENTFUL", function () { return $e62c9da570d0cc47$export$7b31a9938ec3ba75; });
const $e62c9da570d0cc47$export$7b31a9938ec3ba75 = 'contentful';

});

parcelRegister("3t7DW", function(module, exports) {
$parcel$export(module.exports, "init", function () { return $be9c067c7be4fda0$export$2cd8252107eb640b; });

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $yhhhl = parcelRequire("yhhhl");

var $konOj = parcelRequire("konOj");

var $f3gS9 = parcelRequire("f3gS9");

var $fuLgT = parcelRequire("fuLgT");

var $eQyIx = parcelRequire("eQyIx");

var $g0QpW = parcelRequire("g0QpW");

var $6mvtm = parcelRequire("6mvtm");

var $eRzlV = parcelRequire("eRzlV");

var $6r14Z = parcelRequire("6r14Z");

var $hgaI1 = parcelRequire("hgaI1");

var $7mHQv = parcelRequire("7mHQv");

var $i2Oi2 = parcelRequire("i2Oi2");

var $hZy36 = parcelRequire("hZy36");

var $3H7QB = parcelRequire("3H7QB");

var $hp3ar = parcelRequire("hp3ar");

var $gLm0b = parcelRequire("gLm0b");

var $6gQvZ = parcelRequire("6gQvZ");

var $idVA4 = parcelRequire("idVA4");

var $hu7gH = parcelRequire("hu7gH");
window.BUILD_KEY = "p-0ae5536349";
window.featureGateBootstrapValues = window.featureGateBootstrapValues || {
    identifiers: {
        analyticsAnonymousId: (0, $fuLgT.default)()
    }
};
(0, $hZy36.configureCastle)();
const $be9c067c7be4fda0$var$SUPPORTED_LOCALES = [
    {
        hrefLang: 'ja',
        langRoute: 'ja'
    },
    {
        hrefLang: 'fr',
        langRoute: 'fr'
    },
    {
        hrefLang: 'de',
        langRoute: 'de'
    },
    {
        hrefLang: 'es',
        langRoute: 'es'
    },
    {
        hrefLang: 'pt-BR',
        langRoute: 'br'
    },
    {
        hrefLang: 'zh-Hans',
        langRoute: 'zh'
    },
    {
        hrefLang: 'ko',
        langRoute: 'ko'
    },
    {
        hrefLang: 'ru',
        langRoute: 'ru'
    },
    {
        hrefLang: 'pl',
        langRoute: 'pl'
    },
    {
        hrefLang: 'it',
        langRoute: 'it'
    },
    {
        hrefLang: 'nl',
        langRoute: 'nl'
    }
];
const $be9c067c7be4fda0$export$2cd8252107eb640b = (Component, query, queryVars, relayApi)=>{
    const analyticsWebClient = (0, $g0QpW.getAnalyticsWebClient)();
    const { locale: locale, path: path } = (0, $hu7gH.parseRoute)(window.location);
    // Get location data for experiments and feature gates from server-provided data
    let locationData;
    // Use server-provided data (no client-side API calls)
    if (typeof window !== 'undefined') locationData = {
        countryIsoCode: window.countryCode || '',
        regionIsoCode: window.regionIsoCode || ''
    };
    const isPerfOnetrustEnabled = (0, $gLm0b.isPerformanceOnetrustEnabled)(typeof window !== 'undefined' ? window.optanonConsentCookie : (0, $gLm0b.extractOptanonConsentCookie)(document.cookie), locationData);
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    isPerfOnetrustEnabled && (0, $eQyIx.initUFO)(analyticsWebClient, path);
    const parsedClientCookies = document.cookie ? (0, $yhhhl.parse)(document.cookie) : {};
    const userAgent = typeof window !== 'undefined' ? window.navigator.userAgent : '';
    const { finalExperimentOverrides: finalExperimentOverrides, finalFeatureGateOverrides: finalFeatureGateOverrides } = (0, $idVA4.processExperimentAndFeatureGateOverrides)(parsedClientCookies, userAgent, isPerfOnetrustEnabled);
    if ((0, $hp3ar.isEdgeCachingPath)(window.location)) {
        // Override for Edge Caching
        (0, $hp3ar.overrideAjsAnonIdFromCookie)();
        (0, $hp3ar.overrideCustomAttributes)();
    }
    (0, $hgaI1.initializeFeatureGatesClient)(window.featureGateBootstrapValues, {
        overrideValues: {
            experimentOverrides: finalExperimentOverrides,
            featureGateOverrides: finalFeatureGateOverrides
        },
        // if performance cookies are disabled, we will skip exposures
        localMode: !isPerfOnetrustEnabled
    }).then(async ()=>{
        try {
            await (0, $3H7QB.DynamicConfigClient).getInstance().initialize({
                bootstrapValues: window.featureGateBootstrapValues
            });
        } catch (error) {
            console.error('Failed to initialize DynamicConfigClient', error);
        }
        const isStatic = typeof window !== 'undefined' && window.IS_STATIC;
        const snapshot = window.relayStoreSnapshot;
        let relayBaseUrl = undefined;
        let relayAuthKey = undefined;
        if (relayApi === (0, $6mvtm.RELAY_API_CONTENTFUL)) {
            relayBaseUrl = (0, $eRzlV.CONTENTFUL_GRAPHQL_API_URL);
            relayAuthKey = window.CONTENTFUL_DELIVERY_KEY_PRODUCT_TEMPLATES;
        }
        const relayEnvironment = (0, $i2Oi2.initRelayEnvironment)(snapshot, relayBaseUrl, relayAuthKey);
        const queryRef = (0, $f3gS9.loadQuery)(relayEnvironment, query, queryVars);
        const canonicalBaseUrl = (0, $6r14Z.getCanonicalBaseUrl)(window.location.hostname, path);
        const pathForCanonical = path ? (0, $6r14Z.canonicalPathForHref)(canonicalBaseUrl, path) : undefined;
        const route = pathForCanonical === undefined ? '' : pathForCanonical === '' ? '' : `/${pathForCanonical}`;
        const page = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6gQvZ.SentryIntlProvider), {
            locale: locale,
            messages: window.SSR_languagePack,
            cookies: document.cookie,
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $f3gS9.RelayEnvironmentProvider), {
                environment: relayEnvironment,
                children: [
                    isStatic && /*#__PURE__*/ (0, $7VQPk.jsx)("link", {
                        rel: "canonical",
                        href: `${canonicalBaseUrl}${route}`
                    }),
                    isStatic && /*#__PURE__*/ (0, $7VQPk.jsx)("link", {
                        rel: "alternate",
                        href: `${canonicalBaseUrl}${route}`,
                        hrefLang: "x-default"
                    }),
                    isStatic && $be9c067c7be4fda0$var$SUPPORTED_LOCALES.map(({ hrefLang: hrefLang, langRoute: langRoute })=>/*#__PURE__*/ (0, $7VQPk.jsx)("link", {
                            rel: "alternate",
                            href: `${canonicalBaseUrl}/${langRoute}${route}`,
                            hrefLang: hrefLang
                        }, hrefLang)),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7mHQv.PageWrapper), {
                        analyticsWebClient: analyticsWebClient,
                        location: window.location,
                        pricing: window.prices,
                        availableProducts: window.availableProducts,
                        userProfile: window.userProfile,
                        userProfileStatus: window.userProfileStatus,
                        userContext: window.userContext,
                        userContextStatus: window.userContextStatus,
                        loggedOutContext: window.loggedOutContext,
                        loggedOutContextStatus: window.loggedOutContextStatus,
                        loggedInContext: window.loggedInContext,
                        loggedInContextStatus: window.loggedInContextStatus,
                        countryCode: window.countryCode,
                        mlTemplateIds: window.mlTemplateIds,
                        keyword: window.keyword,
                        anchor: window.anchor,
                        subAnchor: window.subAnchor,
                        queryRef: queryRef,
                        PageComponent: Component,
                        transactionAccounts: window.transactionAccounts,
                        userAgent: userAgent
                    })
                ]
            })
        });
        if (isStatic) {
            // @ts-expect-error type
            const root = (0, $konOj.createRoot)(document.getElementById('wac'));
            root.render(page);
        } else (0, $konOj.hydrateRoot)(// @ts-expect-error type
        document.getElementById('wac-root'), page, {
            onRecoverableError: (error, errorInfo)=>{
                document.getElementById('wac-root')?.setAttribute('hydration-error', 'true');
            }
        });
    });
};

});
parcelRegister("i2Oi2", function(module, exports) {
$parcel$export(module.exports, "initRelayEnvironment", function () { return $36b5b9e576032b2f$export$1456be3de97c862f; });

var $gRpMo = parcelRequire("gRpMo");
(0, $gRpMo.RelayFeatureFlags).ENABLE_LOAD_QUERY_REQUEST_DEDUPING = true;
// TODO: Lift this into environment
const $36b5b9e576032b2f$var$GATEWAY_URL = 'https://www.atlassian.com/gateway/api/graphql';
function $36b5b9e576032b2f$var$createRelayEnvironment(initialRecords, baseUrlOverride, authToken) {
    const baseUrl = baseUrlOverride ?? $36b5b9e576032b2f$var$GATEWAY_URL;
    let headers = {
        'Content-Type': 'application/json'
    };
    if (authToken) headers = Object.assign({}, headers, {
        Authorization: `Bearer ${authToken}`
    });
    const fetchResponse = (params, variables)=>{
        const startTime = Date.now();
        const response = fetch(baseUrl, {
            method: 'POST',
            headers: headers,
            // Contentful uses an authToken, and Access-Control-Allow-Origin = "*",
            // therefore we cannot include credentials for Contentful queries
            credentials: authToken ? 'same-origin' : 'include',
            body: JSON.stringify({
                query: params.text,
                variables: variables
            })
        });
        return (0, $gRpMo.Observable).from(response.then(async (res)=>{
            const duration = Date.now() - startTime;
            // @ts-ignore
            if (!globalThis.IS_STATIC) try {
                // @ts-ignore
                globalThis.metrics.histogram(`contentful.duration`, '10_100_500_1000_2000_3000_5000_10000_30000', duration, {
                    gqlOperationName: params.name,
                    cacheStatus: res.headers.get('x-cache'),
                    status: res.status
                });
            } catch (e) {
                console.error(`Failed to track ${params.name} call`, e);
            }
            return res.json();
        }));
    };
    const network = (0, $gRpMo.Network).create(fetchResponse);
    const store = new (0, $gRpMo.Store)(new (0, $gRpMo.RecordSource)(initialRecords));
    return new (0, $gRpMo.Environment)({
        network: network,
        store: store
    });
}
let $36b5b9e576032b2f$var$clientSideRelayEnvironment;
function $36b5b9e576032b2f$export$1456be3de97c862f(initialRecords, baseUrlOverride, authToken) {
    const environment = $36b5b9e576032b2f$var$clientSideRelayEnvironment ?? $36b5b9e576032b2f$var$createRelayEnvironment(initialRecords, baseUrlOverride, authToken);
    if (typeof window === 'undefined') return environment;
    if (!$36b5b9e576032b2f$var$clientSideRelayEnvironment) $36b5b9e576032b2f$var$clientSideRelayEnvironment = environment;
    else if (initialRecords) environment.getStore().publish(new (0, $gRpMo.RecordSource)(initialRecords));
    return $36b5b9e576032b2f$var$clientSideRelayEnvironment;
}

});


parcelRegister("koI83", function(module, exports) {
$parcel$export(module.exports, "getPricingTitleInternal", function () { return $31a5684656309797$export$933c1404a4ee79b; });
const $31a5684656309797$export$933c1404a4ee79b = ()=>{
    return 'Jira Pricing Page';
};

});

parcelRegister("Q2S5p", function(module, exports) {
$parcel$export(module.exports, "JiraSoftwarePricingPage", function () { return $3f3699cf5f70cbd9$export$743fd6231b24dcf9; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $dl2JF = parcelRequire("dl2JF");

var $bTseT = parcelRequire("bTseT");

var $5yFib = parcelRequire("5yFib");

var $4X0dO = parcelRequire("4X0dO");

var $hZuN8 = parcelRequire("hZuN8");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");
const $3f3699cf5f70cbd9$export$743fd6231b24dcf9 = ({ pricing: pricing, countryCode: countryCode, pricingContent: pricingContent, queryRef: queryRef })=>{
    // FYI, this is currently JA only, since we only have JA work space appId
    const isBootIntercom = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp737EnableIntercomChatJsw);
    const [hasFired, fireExposure] = (0, $hZuN8.useExperimentExposure)((0, $4X0dO.experiments).jiraPricingWaeMigrationExperimentRerunExp);
    (0, $1oC0p.useEffect)(()=>{
        if (!hasFired) fireExposure();
    }, [
        hasFired,
        fireExposure
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bTseT.IntercomProvider), {
        appId: 'p0ww63i2',
        triggerBoot: isBootIntercom,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dl2JF.PricingContentContextProvider), {
            productId: "jira-software",
            pricingContent: pricingContent,
            queryRef: queryRef,
            children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5yFib.JiraSoftwarePricingPageV2Template), {
                    pricing: pricing,
                    countryCode: countryCode
                })
            })
        })
    });
};

});
parcelRegister("bTseT", function(module, exports) {
$parcel$export(module.exports, "IntercomProvider", function () { return $d787a990cb9c57de$export$5091c5023e5c7eba; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $6GqRO = parcelRequire("6GqRO");

var $5Ntyw = parcelRequire("5Ntyw");

var $cIXzQ = parcelRequire("cIXzQ");
const $d787a990cb9c57de$var$isWindowExist = typeof window !== 'undefined';
const $d787a990cb9c57de$export$e578ca56db818a8e = /*#__PURE__*/ $1oC0p.createContext(undefined);
const $d787a990cb9c57de$export$5091c5023e5c7eba = ({ appId: appId, triggerBoot: triggerBoot = false, children: children })=>{
    const isBooted = $1oC0p.useRef(false);
    const isInit = $1oC0p.useRef(false);
    const stargateClient = (0, $5Ntyw.useBxpWebStargateClient)();
    const initIntercomInstance = $1oC0p.useCallback(()=>{
        if (!isInit.current) {
            (0, $cIXzQ.default)(appId);
            isInit.current = true;
        }
    }, [
        appId
    ]);
    // Ensure DOM is fully ready and stable before Intercom initialization
    const ensureDOMReady = $1oC0p.useCallback(()=>{
        return new Promise((resolve)=>{
            if (document.readyState === 'complete') // DOM is ready, but add buffer time for iframe stability
            setTimeout(resolve, 500);
            else {
                // Wait for DOM completion, then add buffer time
                const cleanup = ()=>{
                    document.removeEventListener('DOMContentLoaded', handleLoad);
                    window.removeEventListener('load', handleLoad);
                };
                const handleLoad = ()=>{
                    cleanup();
                    clearTimeout(safetyTimeout);
                    setTimeout(resolve, 500);
                };
                // Add event listeners for DOM ready
                document.addEventListener('DOMContentLoaded', handleLoad);
                window.addEventListener('load', handleLoad);
                // Safety timeout: resolve after 10 seconds even if events don't fire
                const safetyTimeout = setTimeout(()=>{
                    cleanup();
                    console.error('Intercom: DOM ready timeout reached, proceeding anyway');
                    resolve();
                }, 10000);
            }
        });
    }, []);
    const boot = $1oC0p.useCallback(async ()=>{
        if ($d787a990cb9c57de$var$isWindowExist && isInit.current && !isBooted.current) {
            const intercomSettings = window.intercomSettings ?? {
                app_id: appId
            };
            try {
                // Wait for DOM to be fully ready and stable
                await ensureDOMReady();
                window.Intercom?.('boot', {
                    alignment: 'right',
                    horizontal_padding: 20,
                    vertical_padding: 20,
                    custom_launcher_selector: '#intercomLauncher',
                    ...intercomSettings
                });
                window.Intercom?.('trackEvent', 'widget-loaded');
            } catch (error) {
                console.warn('Intercom boot failed:', error);
            } finally{
                isBooted.current = true; // Set value as true to enable functionality of show/hide methods
            }
        }
    }, [
        appId,
        ensureDOMReady
    ]);
    const shutdown = $1oC0p.useCallback(()=>{
        if (!isBooted.current) return;
        if ($d787a990cb9c57de$var$isWindowExist) {
            window.Intercom?.('shutdown');
            delete window.intercomSettings;
            isBooted.current = false;
        }
    }, []);
    const show = $1oC0p.useCallback(()=>{
        if ($d787a990cb9c57de$var$isWindowExist && isBooted.current) window.Intercom?.('show');
    }, []);
    const hide = $1oC0p.useCallback(()=>{
        if ($d787a990cb9c57de$var$isWindowExist && isBooted.current) window.Intercom?.('hide');
    }, []);
    $1oC0p.useEffect(()=>{
        if ($d787a990cb9c57de$var$isWindowExist && triggerBoot) (async function() {
            const intercomSettingsObj = {
                app_id: appId
            };
            const anonId = (0, $6GqRO.default).get('ajs_anonymous_id') || '';
            if (anonId) intercomSettingsObj['anonymousId'] = anonId;
            const getwayApiMeGetResponse = await stargateClient.me({}).catch(()=>null);
            if (getwayApiMeGetResponse) {
                intercomSettingsObj['name'] = getwayApiMeGetResponse.name;
                intercomSettingsObj['email'] = getwayApiMeGetResponse.email;
            }
            if ($d787a990cb9c57de$var$isWindowExist) window.intercomSettings = intercomSettingsObj;
            if (!isInit.current) initIntercomInstance();
            if (isInit.current && !isBooted.current) boot();
        })();
        // clean up code
        return ()=>{
            if (isInit.current) shutdown();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        triggerBoot,
        stargateClient
    ]);
    const providerValue = $1oC0p.useMemo(()=>{
        return {
            initIntercomInstance: initIntercomInstance,
            boot: boot,
            shutdown: shutdown,
            show: show,
            hide: hide
        };
    }, [
        initIntercomInstance,
        boot,
        shutdown,
        show,
        hide
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)($d787a990cb9c57de$export$e578ca56db818a8e.Provider, {
        value: providerValue,
        children: children
    });
};
const $d787a990cb9c57de$export$28418e623d2470bc = ()=>{
    const context = $1oC0p.useContext($d787a990cb9c57de$export$e578ca56db818a8e);
    if (context === undefined) throw new Error('This hook must be used within IntercomProvider');
    return context;
};

});
parcelRegister("cIXzQ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $578d2b441e63143c$export$2e2bcd8739ae039; });
function $578d2b441e63143c$var$isIELikeWindow(w) {
    return Object.prototype.hasOwnProperty.call(w, 'attachEvent');
}
// Function per instruction here: https://developers.intercom.com/installing-intercom/web/installation/
const $578d2b441e63143c$var$initializeIntercomInstance = (appId)=>{
    const w = window;
    const ic = w.Intercom;
    if (typeof ic === 'function') {
        ic('reattach_activator');
        ic('update', w.intercomSettings);
    } else {
        const d = document;
        const i = function() {
            i.c(arguments);
        };
        i.q = [];
        i.c = function(args) {
            i.q.push(args);
        };
        w.Intercom = i;
        const l = function() {
            const s = d.createElement('script');
            s.type = 'text/javascript';
            s.async = true;
            s.src = 'https://widget.intercom.io/widget/' + appId;
            const x = d.getElementsByTagName('script')[0];
            x?.parentNode?.insertBefore(s, x);
        };
        if (document.readyState === 'complete') l();
        else if ($578d2b441e63143c$var$isIELikeWindow(w)) w.attachEvent('onload', l);
        else w.addEventListener('load', l, false);
    }
};
var $578d2b441e63143c$export$2e2bcd8739ae039 = $578d2b441e63143c$var$initializeIntercomInstance;

});


parcelRegister("5yFib", function(module, exports) {
$parcel$export(module.exports, "JiraSoftwarePricingPageV2Template", function () { return $cdf4d25a3c43b2b5$export$413c805c73a21678; });

var $7VQPk = parcelRequire("7VQPk");

var $in5fb = parcelRequire("in5fb");

var $kIC93 = parcelRequire("kIC93");

var $7aKDf = parcelRequire("7aKDf");

var $dl2JF = parcelRequire("dl2JF");

var $bE8d4 = parcelRequire("bE8d4");

var $2zOxm = parcelRequire("2zOxm");

var $6Px6U = parcelRequire("6Px6U");

var $grcEk = parcelRequire("grcEk");

var $frz5c = parcelRequire("frz5c");

var $5S2vX = parcelRequire("5S2vX");

var $8IN8s = parcelRequire("8IN8s");

var $b7CnU = parcelRequire("b7CnU");
const $cdf4d25a3c43b2b5$export$413c805c73a21678 = (props)=>{
    const content = (0, $dl2JF.usePricingContentContext)();
    const questionsCtaContent = content?.callToActionContainer?.[0];
    const dataCenterContent = (0, $dl2JF.useDatacenterPlans)('Contact Us', 'Learn more');
    const featuresCtaContent = content?.callToActionContainer?.[1];
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $grcEk.PricingPageLayout), {
        nav: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8IN8s.default), {}),
        showFallback: content?.hasError,
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $5S2vX.ParentScrollTracking), {
            scrollTrackingEnabled: true,
            pageId: "jira-software-pricing-page",
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6Px6U.PageHeading), {
                    children: content?.headline
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $b7CnU.JiraPriceFinder), {
                    pricing: props.pricing,
                    countryCode: props.countryCode
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7aKDf.PricingFeatureTable), {
                    title: content?.compareFeaturesTitle ?? undefined,
                    comparePlans: content?.comparePlans ?? undefined,
                    compareFeatures: content?.compareFeatures ?? undefined,
                    linkValues: {
                        linkText: featuresCtaContent?.text ?? undefined,
                        linkHref: featuresCtaContent?.url ?? undefined
                    },
                    dataProductKey: 'jiraSoftware',
                    stickyCtasEnabled: false
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $in5fb.DataCenterPromoCard), {
                    dataCenterContent: dataCenterContent
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kIC93.TwcPromo), {
                    product: "jira"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2zOxm.QuotationsAdornment), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5S2vX.ParentScrollTracking), {
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bE8d4.PricingFaq), {
                            header: content?.getMoreDetailsTitle ?? undefined,
                            planDetails: content?.additionalDetails ?? undefined
                        })
                    })
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $frz5c.QuestionsCta), {
                    product: 'Jira',
                    ctaHref: questionsCtaContent?.url ?? undefined,
                    questionsHeader: questionsCtaContent?.title ?? undefined,
                    priceAndLicensingLinkText: questionsCtaContent?.text ?? undefined,
                    questionsBody: questionsCtaContent?.valueProposition ?? undefined,
                    imageHref: questionsCtaContent?.asset?.url
                })
            ]
        })
    });
};

});
parcelRegister("in5fb", function(module, exports) {
$parcel$export(module.exports, "DataCenterPromoCard", function () { return $a35fac25401ec131$export$3e66a33f1e68491c; });
/* data-center-promo-card.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $NtjLk = parcelRequire("NtjLk");
const $a35fac25401ec131$export$3e66a33f1e68491c = ({ dataCenterContent: dataCenterContent })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
        className: (0, $2jatx.default)([
            "_1bsbauwl _1pfh1ejb"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $NtjLk.Card), {
            orientation: "horizontal",
            columns: 10,
            title: dataCenterContent.title,
            body: dataCenterContent.description,
            callToAction: {
                text: 'Learn more',
                href: '/enterprise/data-center'
            },
            // eslint-disable-next-line local/no-non-orangelogic-images-eslint
            spotIllustration: {
                src: 'https://wac-cdn.atlassian.com/misc-assets/webp-images/Illo_DataCenter.svg'
            }
        })
    });
};

});

parcelRegister("kIC93", function(module, exports) {
$parcel$export(module.exports, "TwcPromo", function () { return $3b570c8d1312e036$export$f72cba571c49850d; });
/* twc-promo.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $2axoc = parcelRequire("2axoc");

var $kbpa7 = parcelRequire("kbpa7");
const $3b570c8d1312e036$export$f72cba571c49850d = ({ product: product })=>{
    const intl = (0, $8e22h.default)();
    let text = intl.formatMessage({
        id: 'TeamworkCollection.promo.jira.body',
        defaultMessage: 'Get Jira, Confluence, Loom, and Rovo in one collection to bring together projects, knowledge, video communication, and AI-powered insights.'
    });
    if (product === 'confluence') text = intl.formatMessage({
        id: 'TeamworkCollection.promo.confluence.body',
        defaultMessage: 'Get Confluence, Jira, Loom, and Rovo in one collection to bring together knowledge, projects, video communication, and AI-powered insights.'
    });
    if (product === 'loom') text = intl.formatMessage({
        id: 'TeamworkCollection.promo.loom.body',
        defaultMessage: 'Get Loom, Jira, Confluence, and Rovo in one collection to bring together video communication, projects, knowledge, and AI-powered insights.'
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
        className: (0, $2jatx.default)([
            "_1bsbauwl _1mouxy5q"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2axoc.ContentBlock), {
            logo: "teamworkCollection",
            title: intl.formatMessage({
                id: 'TeamworkCollection.promo.title',
                defaultMessage: 'All your tools, one collection'
            }),
            text: text,
            callToActionProps: {
                link: {
                    text: intl.formatMessage({
                        id: 'TeamworkCollection.promo.body',
                        defaultMessage: 'Explore Teamwork Collection'
                    }),
                    href: '/collections/teamwork'
                }
            },
            imageProps: {
                src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/1q83t675w16167510pu524e7ccp6n551.png',
                alt: ''
            },
            orientation: "horizontal-reverse",
            columns: 12,
            backgroundColor: `${(0, $kbpa7.wacToken)('color.extended.blue100')}`,
            hat: "high-right"
        })
    });
};

});

parcelRegister("grcEk", function(module, exports) {
$parcel$export(module.exports, "PricingPageLayout", function () { return $229e6cc32b6909b5$export$179602f42864b2b8; });
/* pricing-page-layout.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iLjCW = parcelRequire("iLjCW");

var $jvvcS = parcelRequire("jvvcS");
const $229e6cc32b6909b5$export$179602f42864b2b8 = ({ nav: nav, banner: banner, hero: hero, bgColor: bgColor, hasGlobalFooter: hasGlobalFooter = true, showFallback: showFallback = false, noInlinePadding: noInlinePadding = false, children: children })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            nav && nav,
            !showFallback && banner,
            !showFallback && hero,
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                style: {
                    background: bgColor
                },
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx21bp4 _1bah1h6o _4cvr1h6o _1q51vbgk _85i5vbgk _xc2ickbl _1u2qzwfg"
                ]),
                children: [
                    showFallback && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jvvcS.PricingPageFallback), {}),
                    !showFallback && children && /*#__PURE__*/ (0, $7VQPk.jsx)("main", {
                        id: "content",
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _2lx21bp4 _1bah1h6o _4cvr1h6o _zulpvbgk _p12ftfvk _1bsbaq80 _vqct1h22 _1wfq1ul9 _15vt1ul9 _v7361wqb _chtu1wqb _8164ckbl _63vr1vh9 _1tbz1ul9 _68811ul9",
                            noInlinePadding && "_bozgidpf _y4tiidpf _1wfqidpf _15vtidpf _v736idpf _chtuidpf _1tbzidpf _6881idpf"
                        ]),
                        children: children
                    })
                ]
            }),
            hasGlobalFooter && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1pfhvbgk _476dckbl"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iLjCW.GlobalFooter), {})
            })
        ]
    });
};
const $229e6cc32b6909b5$var$footerCss = null;
const $229e6cc32b6909b5$var$pricingPageLayoutOuterCss = null;
const $229e6cc32b6909b5$var$pricingPageLayoutInnerCss = null;
// Opt-in override for full-bleed pricing pages (e.g. usage-based pricing
// calculator). Strips the inline padding at every breakpoint so the child
// content can span the full inner-max-width.
const $229e6cc32b6909b5$var$pricingPageLayoutInnerNoPaddingCss = null;

});
parcelRegister("jvvcS", function(module, exports) {
$parcel$export(module.exports, "PricingPageFallback", function () { return $a5f2023cdede46a1$export$54fc8f6b9874893e; });
/* pricing-page-fallback.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");
const $a5f2023cdede46a1$export$54fc8f6b9874893e = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_4t3idtre _1e0c1txw _4cvr1h6o"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "PageFallback.message",
            defaultMessage: "An unexpected error occurred. Please try again later."
        })
    });
};

});


parcelRegister("frz5c", function(module, exports) {
$parcel$export(module.exports, "QuestionsCta", function () { return $a5fd4efc00df1131$export$7874bf850b18c607; });
/* questions-cta.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");
var $8e22h = parcelRequire("8e22h");

var $iPPTB = parcelRequire("iPPTB");

var $hnmMQ = parcelRequire("hnmMQ");
const $a5fd4efc00df1131$var$containerCss = null;
const $a5fd4efc00df1131$var$sectionLeftCss = null;
const $a5fd4efc00df1131$var$sectionLeftTextCss = null;
const $a5fd4efc00df1131$var$headingCss = null;
const $a5fd4efc00df1131$var$svgStyles = null;
const $a5fd4efc00df1131$export$7874bf850b18c607 = ({ questionsHeader: questionsHeader, questionsBody: questionsBody, priceAndLicensingLinkText: priceAndLicensingLinkText, ctaHref: ctaHref, imageHref: imageHref = 'https://dam-cdn.atl.orangelogic.com/AssetLink/0s31nt386q2lt662011182pvct037sp1.svg', product: product })=>{
    const intl = (0, $8e22h.default)();
    if (!ctaHref || !product && !questionsBody) return null;
    const fallbackQuestionsHeader = intl.formatMessage({
        id: 'PricingPage.QuestionsCta.questionsHeader',
        defaultMessage: 'Questions?'
    });
    const fallbackQuestionsBody = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
        id: "PricingPage.QuestionsCta.questionsBody",
        defaultMessage: "We got answers. Read our full list of common questions and answers for general cloud pricing and licensing or specific {product} pricing and licensing.",
        values: {
            product: product
        }
    });
    const text = intl.formatMessage({
        id: 'PricingPage.QuestionsCta.priceAndLicensingLinkText',
        defaultMessage: 'See price and licensing page'
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_4cvr1y6m _1bah1h6o _bfhkr3uz _1e0c1txw _syazu67f _1reoewfl _18m9ewfl _ca0qvbgk _u5f31uvc _n3tdvbgk _19bvd3xy _2osnqslr _8fz61fdn _tl28vbgk _axwi1l27 _1hwc1et3 _sp8t1l27 _1gde1sxn _1vth1hhm _mkrz22xr _zulpt9kd"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx21bp4 _4cvr1y6m _y3gn1e5h _zulp7vkz _85i519bv _xlt110yn"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                        "data-testid": "questions-cta-header",
                        className: (0, $2jatx.default)([
                            "_1wybzwfg _vwz410mc _so7d1f4h _19q11u1b _1cqs1tcg _1bys1ul9",
                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _syazu67f"
                        ]),
                        children: questionsHeader ?? fallbackQuestionsHeader
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        "data-testid": "questions-cta-body",
                        className: (0, $2jatx.default)([
                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _syazu67f"
                        ]),
                        children: questionsBody ?? fallbackQuestionsBody
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                        text: priceAndLicensingLinkText ?? text,
                        "aria-label": priceAndLicensingLinkText ?? text,
                        href: ctaHref,
                        anchorProps: {
                            'data-testid': 'questions-cta-link'
                        },
                        bgColor: 'bgBlackBlue'
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                image: {
                    src: imageHref,
                    alt: ''
                },
                className: (0, $2jatx.default)([
                    "_1bsb7l9q _4t3irb92 _1s4pnxnw _1kne1yvi"
                ])
            })
        ]
    });
};
$a5fd4efc00df1131$export$7874bf850b18c607.displayName = 'QuestionsCTASection';

});

parcelRegister("5S2vX", function(module, exports) {
$parcel$export(module.exports, "useParentScrollTracking", function () { return $d703c208f3e9c795$export$164ddb76b909974a; });
$parcel$export(module.exports, "ParentScrollTracking", function () { return $d703c208f3e9c795$export$248f1dfc9396e7e4; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $je135 = parcelRequire("je135");
const $d703c208f3e9c795$var$ScrollTrackingContext = /*#__PURE__*/ (0, $1oC0p.createContext)({
    pageId: 'wac-web',
    scrollTrackingEnabled: true
});
const $d703c208f3e9c795$export$164ddb76b909974a = ()=>{
    return (0, $1oC0p.useContext)($d703c208f3e9c795$var$ScrollTrackingContext);
};
const $d703c208f3e9c795$export$248f1dfc9396e7e4 = (props)=>{
    const parentContext = $d703c208f3e9c795$export$164ddb76b909974a();
    const arrayChildren = (0, $1oC0p.Children).toArray(props.children);
    const definedName = (child)=>{
        if (/*#__PURE__*/ (0, $1oC0p.isValidElement)(child) && child.type) {
            // Use a type assertion to tell TypeScript that the type has a displayName
            const namedComponent = child.type;
            return namedComponent.displayName;
        } else return undefined;
    };
    // Determine tracking of parent undefined means true
    const parentTrackScrolling = parentContext.scrollTrackingEnabled === undefined ? true : parentContext.scrollTrackingEnabled;
    // Parent should take precedence if parent tracking is disabled
    const trackScrolling = parentTrackScrolling && (props.scrollTrackingEnabled === undefined ? true : props.scrollTrackingEnabled);
    const pageId = props.pageId ?? parentContext.pageId;
    return /*#__PURE__*/ (0, $7VQPk.jsx)($d703c208f3e9c795$var$ScrollTrackingContext.Provider, {
        value: {
            pageId: pageId,
            scrollTrackingEnabled: trackScrolling
        },
        children: (0, $1oC0p.Children).map(arrayChildren, (child, index)=>{
            const name = definedName(child);
            return name ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $je135.ScrollTracking), {
                index: `${index}/${arrayChildren.length}`,
                section: name,
                as: props.as,
                children: child
            }, index) : child;
        })
    });
};

});
parcelRegister("je135", function(module, exports) {
$parcel$export(module.exports, "useScrollTracking", function () { return $0fbf1a9bc3d0315b$export$17700584f55fbc70; });
$parcel$export(module.exports, "ScrollTracking", function () { return $0fbf1a9bc3d0315b$export$1725757b7947b890; });
$parcel$export(module.exports, "withScrollTracking", function () { return $0fbf1a9bc3d0315b$export$391633ede08dabb1; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $jKShK = parcelRequire("jKShK");

var $eY3N6 = parcelRequire("eY3N6");

var $5S2vX = parcelRequire("5S2vX");

var $iSeHD = parcelRequire("iSeHD");
const $0fbf1a9bc3d0315b$export$17700584f55fbc70 = (section, props = {})=>{
    const { index: index, observerOptions: observerOptions, dwellTimeEnabled: dwellTimeEnabled, additionalAttributes: additionalAttributes } = props;
    const hasFunctionBeenCalled = (0, $1oC0p.useRef)(false);
    const scrollPercentage = (0, $1oC0p.useRef)(0);
    const { pageId: pageId, scrollTrackingEnabled: scrollTrackingEnabled } = (0, $5S2vX.useParentScrollTracking)();
    const { ref: ref, inView: inView, entry: entry } = (0, $jKShK.useInView)({
        threshold: 0.5,
        triggerOnce: true,
        ...observerOptions,
        skip: observerOptions?.skip || !scrollTrackingEnabled
    });
    const analyticsClient = (0, $iSeHD.useAnalyticsClient)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const handleScroll = ()=>{
        const windowHeight = window.innerHeight;
        const fullHeight = document.documentElement.scrollHeight;
        const currentPosition = window.scrollY;
        scrollPercentage.current = Math.round(currentPosition / (fullHeight - windowHeight) * 100);
    };
    (0, $1oC0p.useEffect)(()=>{
        if (inView && !hasFunctionBeenCalled.current && section) {
            handleScroll();
            const scrollTrackAnalyticsPayload = {
                eventType: 'ui',
                action: 'scrolledTo',
                actionSubject: 'section',
                source: window.location.pathname,
                attributes: {
                    section: section,
                    scrollPercentage: scrollPercentage.current,
                    pageChildIndex: index,
                    pageId: pageId,
                    ...additionalAttributes
                }
            };
            const dwellTimeTrackAnalyticsPayload = {
                eventType: 'ui',
                action: 'dwellTimeTracked',
                actionSubject: 'section',
                source: window.location.pathname,
                attributes: {
                    section: section,
                    scrollPercentage: scrollPercentage.current,
                    pageChildIndex: index,
                    pageId: pageId,
                    ...additionalAttributes
                }
            };
            if (analyticsClient) {
                createAnalyticsEvent({
                    ...scrollTrackAnalyticsPayload
                }).fire();
                hasFunctionBeenCalled.current = true;
            }
            if (dwellTimeEnabled) {
                const activityEvents = [
                    'mousemove',
                    'keydown',
                    'scroll',
                    'touchstart'
                ];
                let intervalId = undefined;
                let activityTimeout = undefined;
                let active = true;
                // stop tracking after 1 minute of inactivity
                const setActive = ()=>{
                    active = true;
                    clearTimeout(activityTimeout);
                    activityTimeout = setTimeout(()=>{
                        active = false;
                    }, 60000);
                };
                activityEvents.forEach((evt)=>{
                    window.addEventListener(evt, setActive);
                });
                // emmit every 5 seconds if the user is active
                intervalId = setInterval(()=>{
                    if (active) {
                        handleScroll();
                        createAnalyticsEvent({
                            ...dwellTimeTrackAnalyticsPayload
                        }).fire();
                    } else {
                        clearInterval(intervalId);
                        clearTimeout(activityTimeout);
                        activityEvents.forEach((evt)=>{
                            window.removeEventListener(evt, setActive);
                        });
                    }
                }, 5000);
            }
        }
    }, [
        additionalAttributes,
        analyticsClient,
        createAnalyticsEvent,
        dwellTimeEnabled,
        hasFunctionBeenCalled,
        inView,
        index,
        pageId,
        section
    ]);
    return {
        ref: ref,
        inView: inView,
        entry: entry
    };
};
const $0fbf1a9bc3d0315b$export$1725757b7947b890 = ({ section: section, index: index, observerOptions: observerOptions, children: children, as: RootElement = 'div' })=>{
    const { ref: ref } = $0fbf1a9bc3d0315b$export$17700584f55fbc70(section, {
        index: index,
        observerOptions: observerOptions
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)(RootElement, {
        ref: ref,
        children: children
    });
};
function $0fbf1a9bc3d0315b$export$391633ede08dabb1(section, InnerComponent, options) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (props)=>{
        return /*#__PURE__*/ (0, $7VQPk.jsx)($0fbf1a9bc3d0315b$export$1725757b7947b890, {
            section: section,
            ...options,
            children: /*#__PURE__*/ (0, $7VQPk.jsx)(InnerComponent, {
                ...props
            })
        });
    };
}

});


parcelRegister("b7CnU", function(module, exports) {
$parcel$export(module.exports, "JiraPriceFinder", function () { return $be32cafd3b047742$export$1bf486cdabb14f4d; });

var $7VQPk = parcelRequire("7VQPk");

var $fnHPc = parcelRequire("fnHPc");

var $hCc2m = parcelRequire("hCc2m");

var $g9ZvA = parcelRequire("g9ZvA");

var $gIRO7 = parcelRequire("gIRO7");

var $eYlij = parcelRequire("eYlij");

var $1qGP5 = parcelRequire("1qGP5");

var $dl2JF = parcelRequire("dl2JF");
const $be32cafd3b047742$export$1bf486cdabb14f4d = (props)=>{
    const content = {
        free: (0, $dl2JF.usePricingPlanComparison)('Free'),
        standard: (0, $dl2JF.usePricingPlanComparison)('Standard'),
        premium: (0, $dl2JF.usePricingPlanComparison)('Premium'),
        enterprise: (0, $dl2JF.usePricingPlanComparison)('Enterprise')
    };
    const freePlanFeatureMessages = (0, $1qGP5.createPlanFeatureMessages)(content, 'free');
    const standardPlanFeatureMessages = (0, $1qGP5.createPlanFeatureMessages)(content, 'standard');
    const premiumPlanFeatureMessages = (0, $1qGP5.createPlanFeatureMessages)(content, 'premium');
    const enterprisePlanFeatureMessages = (0, $1qGP5.createPlanFeatureMessages)(content, 'enterprise');
    const signupLimit = 100000;
    // planNames should not be translated
    const jswProductPlans = [
        {
            planName: content.free?.planTitleExternal ?? 'Free',
            offeringSku: 'jira-software-free',
            description: content.free?.planOneLiner ?? '',
            recommendationLimit: 0,
            signupLimit: signupLimit,
            signupURLSuffix: '?bundle=jira-software&edition=free&editionIntent=free&signupSource=pricing',
            planFeatureMessages: freePlanFeatureMessages
        },
        {
            planName: content.standard?.planTitleExternal ?? 'Standard',
            offeringSku: 'jira-software-standard',
            description: content.standard?.planOneLiner ?? '',
            recommendationLimit: 10,
            signupLimit: signupLimit,
            signupURLSuffix: '?bundle=jira-software&edition=standard&signupSource=pricing',
            planFeatureMessages: standardPlanFeatureMessages
        },
        {
            planName: content.premium?.planTitleExternal ?? 'Premium',
            offeringSku: 'jira-software-premium',
            description: content.premium?.planOneLiner ?? '',
            recommendationLimit: 250,
            signupLimit: signupLimit,
            signupURLSuffix: '?bundle=jira-software&edition=premium&signupSource=pricing',
            planFeatureMessages: premiumPlanFeatureMessages
        },
        {
            planName: content.enterprise?.planTitleExternal ?? 'Enterprise',
            offeringSku: 'jira-software-enterprise-sku',
            recommendationLimit: 5000,
            description: content.enterprise?.planOneLiner ?? '',
            signupLimit: signupLimit,
            planFeatureMessages: enterprisePlanFeatureMessages
        }
    ];
    const messages = (0, $fnHPc.defineMessages)({
        headerText: {
            id: 'JiraSoftwarePricingPageV2.priceFinder.header',
            defaultMessage: '<blue>Simple, transparent pricing</blue> for every team.'
        },
        unitCountInputText: {
            id: 'JiraSoftwarePricingPage.priceFinder.unitCountInputText',
            defaultMessage: 'How many users are on your team?'
        },
        unitCountInputTextRedesign: {
            id: 'JiraSoftwarePricingPage.priceFinder.unitCountInputTextRedesign',
            defaultMessage: 'Team size:'
        },
        unitCountInputDirectBuy: {
            id: 'JiraSoftwarePricingPage.priceFinder.unitCountInputDirectBuy',
            defaultMessage: "What's your team size?"
        },
        unitCountInputTerm: {
            id: 'JiraSoftwarePricingPage.priceFinder.unitCountInputTerm',
            defaultMessage: 'users'
        },
        billingCycleText: {
            id: 'JiraSoftwarePricingPage.priceFinder.billingCycleText',
            defaultMessage: 'Billing cycle:'
        },
        unitCountInputTooltip: {
            id: 'JiraSoftwarePricingPage.priceFinder.unitCountInputTooltip',
            defaultMessage: 'A Jira Software user is any user who can log in to Jira Software, and who exists in User Management'
        },
        cardOverSignupLimit: {
            id: 'JiraSoftwarePricingPage.priceFinder.cardOverSignupLimit',
            defaultMessage: "Your user count exceeds this plan's limit"
        },
        cardEnterpriseMinimumCount: {
            id: 'JiraSoftwarePricingPage.priceFinder.cardEnterpriseMinimumCount',
            defaultMessage: 'Enterprise plan pricing is available when you enter {enterpriseMinimumCount} or more users above',
            description: 'Enterprise is a plan name and should not be translated'
        },
        cardUnitCountTierRange: {
            id: 'JiraSoftwarePricingPage.priceFinder.cardUnitCountTierRange',
            defaultMessage: 'User tier: {lowerLimit} - {upperLimit}'
        },
        cardMonthlyPerUnitCount: {
            id: 'JiraSoftwarePricingPageV2.priceFinder.cardMonthlyPerUnitCount',
            defaultMessage: 'per user / month'
        },
        cardFreeDescription: {
            id: 'JiraSoftwarePricingPage.priceFinder.cardFreeDescription',
            defaultMessage: 'Always free for 10 users'
        }
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hCc2m.default), {
        interactionName: 'jira-price-finder',
        fallback: (0, $g9ZvA.LoadingSpinner),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $eYlij.PriceFinderContextProvider), {
            productPlans: jswProductPlans,
            dataProductKey: "jiraSoftware",
            defaultUnitCount: 300,
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gIRO7.default), {
                messages: messages,
                serverSideCCPPricing: props.pricing?.ccpPricingData?.jiraSoftware,
                countryCode: props.countryCode
            })
        })
    });
};
$be32cafd3b047742$export$1bf486cdabb14f4d.displayName = 'JiraPriceFinder';

});
parcelRegister("1qGP5", function(module, exports) {
$parcel$export(module.exports, "createPlanFeatureMessages", function () { return $9f8554c0837366fe$export$8fd76139fda318d8; });

var $7VQPk = parcelRequire("7VQPk");
const $9f8554c0837366fe$export$68568ac1e2cced1f = (highlightedFeatures)=>{
    return highlightedFeatures.map((highlight)=>({
            featureMessage: highlight.highlightedFeatureDetails ? {
                text: highlight.highlightedFeatureTitleExternal,
                content: ()=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        dangerouslySetInnerHTML: {
                            __html: highlight.highlightedFeatureDetails
                        }
                    })
            } : highlight.highlightedFeatureTitleExternal,
            lozengeText: highlight.callOut
        }));
};
const $9f8554c0837366fe$export$8fd76139fda318d8 = (content, planKey)=>{
    const plan = content?.[planKey];
    return plan?.highlightedFeaturesContainer ? $9f8554c0837366fe$export$68568ac1e2cced1f(plan.highlightedFeaturesContainer) : [];
};

});



parcelRegister("hZuN8", function(module, exports) {
$parcel$export(module.exports, "useExperimentExposure", function () { return $ee7a1e494f36b086$export$704ae2e2a6903e4c; });

var $1oC0p = parcelRequire("1oC0p");

var $gIKKj = parcelRequire("gIKKj");
function $ee7a1e494f36b086$export$704ae2e2a6903e4c(experiment, metadata = {}) {
    const { experimentName: experimentName, options: options } = experiment;
    const experimentStatus = (0, $gIKKj.useExperiment)(experiment, metadata);
    const [exposureFired, setExposureFired] = (0, $1oC0p.useState)(()=>{
        return experimentStatus.type === 'enrolled' && options.fireExperimentExposure;
    });
    const fireExposure = (0, $1oC0p.useCallback)(()=>{
        if (exposureFired) console.warn(`Exposure event for ${experimentName} already fired.`);
        else if (experimentStatus.type === 'enrolled') {
            experimentStatus.fireExposure();
            setExposureFired(true);
        } else console.warn(`Exposure event not fired for ${experimentName}; status is not enrolled or indeterminate.`);
    }, [
        exposureFired,
        experimentName,
        experimentStatus
    ]);
    return [
        exposureFired,
        fireExposure
    ];
}

});


parcelRegister("ixLXc", function(module, exports) {
'use strict';

module.exports = (parcelRequire("3H9Cb"));

});
parcelRegister("3H9Cb", function(module, exports) {
$parcel$export(module.exports, "useSyncExternalStore", function () { return $2b0cd8895c4bf8a0$export$306c0aa65ff9ec16; }, function (v) { return $2b0cd8895c4bf8a0$export$306c0aa65ff9ec16 = v; });
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $2b0cd8895c4bf8a0$export$306c0aa65ff9ec16;
"use strict";

var $1oC0p = parcelRequire("1oC0p");
function $2b0cd8895c4bf8a0$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $2b0cd8895c4bf8a0$var$objectIs = "function" === typeof Object.is ? Object.is : $2b0cd8895c4bf8a0$var$is, $2b0cd8895c4bf8a0$var$useState = $1oC0p.useState, $2b0cd8895c4bf8a0$var$useEffect = $1oC0p.useEffect, $2b0cd8895c4bf8a0$var$useLayoutEffect = $1oC0p.useLayoutEffect, $2b0cd8895c4bf8a0$var$useDebugValue = $1oC0p.useDebugValue;
function $2b0cd8895c4bf8a0$var$useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = $2b0cd8895c4bf8a0$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    $2b0cd8895c4bf8a0$var$useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        $2b0cd8895c4bf8a0$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $2b0cd8895c4bf8a0$var$useEffect(function() {
        $2b0cd8895c4bf8a0$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            $2b0cd8895c4bf8a0$var$checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    $2b0cd8895c4bf8a0$var$useDebugValue(value);
    return value;
}
function $2b0cd8895c4bf8a0$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$2b0cd8895c4bf8a0$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $2b0cd8895c4bf8a0$var$useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var $2b0cd8895c4bf8a0$var$shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $2b0cd8895c4bf8a0$var$useSyncExternalStore$1 : $2b0cd8895c4bf8a0$var$useSyncExternalStore$2;
$2b0cd8895c4bf8a0$export$306c0aa65ff9ec16 = void 0 !== $1oC0p.useSyncExternalStore ? $1oC0p.useSyncExternalStore : $2b0cd8895c4bf8a0$var$shim;

});


parcelRegister("lOlsU", function(module, exports) {
$parcel$export(module.exports, "useFirePricingPlanCtaEvent", function () { return $94595cb38e128ae6$export$7f90eaa475fc1c9f; });

var $fuLgT = parcelRequire("fuLgT");

var $eY3N6 = parcelRequire("eY3N6");
function $94595cb38e128ae6$export$7f90eaa475fc1c9f(props) {
    const { edition: edition, productKey: productKey, containerId: containerId } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const createPayload = ()=>({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'linkButton',
            containerId: containerId,
            actionSubjectId: 'pricingPlanCta',
            attributes: {
                migrationExperimentCta: true,
                pricingEventId: (0, $fuLgT.default)(),
                productKey: productKey,
                edition: edition
            }
        });
    return ()=>createAnalyticsEvent(createPayload()).fire();
}

});

parcelRegister("cwszX", function(module, exports) {
$parcel$export(module.exports, "InfoIcon", function () { return $a32037f0fe1c069c$export$2957fc44b3d2481; });

var $7VQPk = parcelRequire("7VQPk");

var $3c7rQ = parcelRequire("3c7rQ");

var $kbpa7 = parcelRequire("kbpa7");
const $a32037f0fe1c069c$export$2957fc44b3d2481 = ({ size: size = 'small' })=>/*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        width: size === 'small' ? '14' : '22',
        height: size === 'small' ? '14' : '22',
        viewBox: "0 0 24 24",
        role: "presentation",
        "aria-hidden": "true",
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("circle", {
                    fill: (0, $kbpa7.wacToken)('color.primary.black'),
                    cx: "12",
                    cy: "12",
                    r: "10"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("circle", {
                    fill: (0, $3c7rQ.N0),
                    cx: "12",
                    cy: "18",
                    r: "1"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M15.89 9.05a3.975 3.975 0 00-2.957-2.942C10.321 5.514 8.017 7.446 8 9.95l.005.147a.992.992 0 00.982.904c.552 0 1-.447 1.002-.998a2.004 2.004 0 014.007-.002c0 1.102-.898 2-2.003 2H12a1 1 0 00-1 .987v2.014a1.001 1.001 0 002.004 0v-.782c0-.217.145-.399.35-.472A3.99 3.99 0 0015.89 9.05",
                    fill: (0, $3c7rQ.N0)
                })
            ]
        })
    });

});

parcelRegister("6FQb9", function(module, exports) {
$parcel$export(module.exports, "createContainer", function () { return $4dbf0c115974ff4b$export$26ae5ca175b4ec5a; });

var $1oC0p = parcelRequire("1oC0p");

var $4OgEb = parcelRequire("4OgEb");

var $djHSy = parcelRequire("djHSy");

var $19KTt = parcelRequire("19KTt");
var $iLhGt = parcelRequire("iLhGt");

var $iEBLg = parcelRequire("iEBLg");
const $4dbf0c115974ff4b$var$_excluded = [
    "children"
], $4dbf0c115974ff4b$var$_excluded2 = [
    "scope",
    "isGlobal"
];
function $4dbf0c115974ff4b$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $4dbf0c115974ff4b$var$noop = ()=>()=>{};
function $4dbf0c115974ff4b$export$26ae5ca175b4ec5a(StoreOrOptions, _temp) {
    if (StoreOrOptions === void 0) StoreOrOptions = {};
    let { onInit: _onInit = $4dbf0c115974ff4b$var$noop, onUpdate: onUpdate = $4dbf0c115974ff4b$var$noop, onCleanup: onCleanup = $4dbf0c115974ff4b$var$noop, displayName: displayName = '' } = _temp === void 0 ? {} : _temp;
    if ('key' in StoreOrOptions) {
        const Store = StoreOrOptions;
        const dn = displayName || `Container(${Store.key.split('__')[0]})`;
        return $4dbf0c115974ff4b$var$createFunctionContainer({
            displayName: dn,
            // compat fields
            override: {
                Store: Store,
                handlers: Object.assign({}, _onInit !== $4dbf0c115974ff4b$var$noop && {
                    onInit: ()=>_onInit()
                }, onCleanup !== $4dbf0c115974ff4b$var$noop && {
                    onDestroy: ()=>onCleanup()
                }, onUpdate !== $4dbf0c115974ff4b$var$noop && {
                    onContainerUpdate: ()=>onUpdate()
                })
            }
        });
    }
    return $4dbf0c115974ff4b$var$createFunctionContainer(StoreOrOptions);
}
function $4dbf0c115974ff4b$var$useRegistry(scope, isGlobal, _ref) {
    let { globalRegistry: globalRegistry } = _ref;
    return (0, $1oC0p.useMemo)(()=>{
        const isLocal = !scope && !isGlobal;
        return isLocal ? new (0, $iLhGt.StoreRegistry)('__local__') : globalRegistry;
    }, [
        scope,
        isGlobal,
        globalRegistry
    ]);
}
function $4dbf0c115974ff4b$var$useContainedStore(scope, registry, propsRef, check, override) {
    // Store contained scopes in a map, but throwing it away on scope change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const containedStores = (0, $1oC0p.useMemo)(()=>new Map(), [
        scope
    ]);
    const getContainedStore = (0, $1oC0p.useCallback)((Store)=>{
        let containedStore = containedStores.get(Store); // first time it gets called we add store to contained map bound
        // so we can provide props to actions (only triggered by children)
        if (!containedStore) {
            const isExisting = registry.hasStore(Store, scope);
            const config = {
                props: ()=>propsRef.current.sub,
                contained: check
            };
            const { storeState: storeState } = registry.getStore(Store, scope, config);
            const actions = (0, $19KTt.bindActions)(Store.actions, storeState, config);
            const handlers = (0, $19KTt.bindActions)(Object.assign({}, Store.handlers, override == null ? void 0 : override.handlers), storeState, config, actions);
            containedStore = {
                storeState: storeState,
                actions: actions,
                handlers: handlers,
                unsubscribe: undefined
            };
            containedStores.set(Store, containedStore); // Signal store is contained and ready now, so by the time
            // consumers subscribe we already have updated the store (if needed).
            // Also if override maintain legacy behaviour, triggered on every mount
            if (!isExisting || override) handlers.onInit == null || handlers.onInit();
        }
        return containedStore;
    }, [
        containedStores,
        scope,
        registry,
        propsRef,
        check,
        override
    ]);
    return [
        containedStores,
        getContainedStore
    ];
}
function $4dbf0c115974ff4b$var$useApi(check, getContainedStore, _ref2) {
    let { globalRegistry: globalRegistry, retrieveStore: retrieveStore } = _ref2;
    const retrieveRef = (0, $1oC0p.useRef)();
    retrieveRef.current = (Store)=>check(Store) ? getContainedStore(Store) : retrieveStore(Store); // This api is "frozen", as changing it will trigger re-render across all consumers
    // so we link retrieveStore dynamically and manually call notify() on scope change
    return (0, $1oC0p.useMemo)(()=>({
            globalRegistry: globalRegistry,
            retrieveStore: (s)=>retrieveRef.current(s)
        }), [
        globalRegistry
    ]);
}
function $4dbf0c115974ff4b$var$createFunctionContainer(_temp2) {
    let { displayName: displayName, override: override } = _temp2 === void 0 ? {} : _temp2;
    const check = (store)=>override ? store === override.Store : store.containedBy === FunctionContainer;
    function FunctionContainer(props) {
        const { children: children } = props, restProps = $4dbf0c115974ff4b$var$_objectWithoutPropertiesLoose(props, $4dbf0c115974ff4b$var$_excluded);
        const { scope: scope, isGlobal: isGlobal } = restProps, subProps = $4dbf0c115974ff4b$var$_objectWithoutPropertiesLoose(restProps, $4dbf0c115974ff4b$var$_excluded2);
        const ctx = (0, $1oC0p.useContext)((0, $djHSy.Context));
        const registry = $4dbf0c115974ff4b$var$useRegistry(scope, isGlobal, ctx); // Store props in a ref to avoid re-binding actions when they change and re-rendering all
        // consumers unnecessarily. The update is handled by an effect on the component instead
        const propsRef = (0, $1oC0p.useRef)({
            prev: null,
            next: restProps,
            sub: subProps
        });
        propsRef.current = {
            prev: propsRef.current.next,
            next: restProps,
            sub: subProps // TODO remove on next major
        };
        const [containedStores, getContainedStore] = $4dbf0c115974ff4b$var$useContainedStore(scope, registry, propsRef, check, override); // Use a stable object as is passed as value to context Provider
        const api = $4dbf0c115974ff4b$var$useApi(check, getContainedStore, ctx); // This listens for custom props change, and so we trigger container update actions
        // before the re-render gets to consumers (hence why side effect on render).
        // We do not use React hooks because num of restProps might change and react will throws
        if (!(0, $iEBLg.default)(propsRef.current.next, propsRef.current.prev)) containedStores.forEach((_ref3)=>{
            let { handlers: handlers } = _ref3;
            handlers.onContainerUpdate == null || handlers.onContainerUpdate(propsRef.current.next, propsRef.current.prev);
        });
         // Every time we add/remove a contained store, we ensure we are subscribed to the updates
        // as an effect to properly handle strict mode
        (0, $1oC0p.useEffect)(()=>{
            containedStores.forEach((containedStore)=>{
                if (!containedStore.unsubscribe) {
                    const unsub = containedStore.storeState.subscribe(()=>containedStore.handlers.onUpdate == null ? void 0 : containedStore.handlers.onUpdate());
                    containedStore.unsubscribe = ()=>{
                        unsub();
                        containedStore.unsubscribe = undefined;
                    };
                }
            });
        }, [
            containedStores,
            containedStores.size
        ]); // We support renderding "bootstrap" containers without children with override API
        // so in this case we call getCS to initialize the store globally asap
        if (override && !containedStores.size && (scope || isGlobal)) getContainedStore(override.Store);
         // This listens for scope change or component unmount, to notify all consumers
        // so all work is done on cleanup
        (0, $1oC0p.useEffect)(()=>{
            return ()=>{
                containedStores.forEach((_ref4, Store)=>{
                    let { storeState: storeState, handlers: handlers, unsubscribe: unsubscribe } = _ref4;
                    // Detatch container from subscription
                    unsubscribe == null || unsubscribe(); // Trigger a forced update on all subscribers as we opted out from context
                    // Some might have already re-rendered naturally, but we "force update" all anyway.
                    // This is sub-optimal as if there are other containers with the same
                    // old scope id we will re-render those too, but still better than context
                    storeState.notify(); // Given unsubscription is handled by useSyncExternalStore, we have no control on when
                    // React decides to do it. So we schedule on next tick to run last
                    Promise.resolve().then(()=>{
                        var _registry$getStore;
                        if (!storeState.listeners().size && // ensure registry has not already created a new store with same scope
                        storeState === ((_registry$getStore = registry.getStore(Store, scope, null)) == null ? void 0 : _registry$getStore.storeState)) {
                            handlers.onDestroy == null || handlers.onDestroy(); // We only delete scoped stores, as global shall persist and local are auto-deleted
                            if (!isGlobal) registry.deleteStore(Store, scope);
                        }
                    });
                }); // no need to reset containedStores as the map is already bound to scope
            };
        }, [
            registry,
            scope,
            isGlobal,
            containedStores
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $djHSy.Context).Provider, {
            value: api
        }, children);
    }
    FunctionContainer.displayName = displayName || `Container`;
    FunctionContainer.propTypes = {
        children: (0, (/*@__PURE__*/$parcel$interopDefault($4OgEb))).node,
        scope: (0, (/*@__PURE__*/$parcel$interopDefault($4OgEb))).string,
        isGlobal: (0, (/*@__PURE__*/$parcel$interopDefault($4OgEb))).bool
    };
    return FunctionContainer;
}

});


var $5UKqd = parcelRequire("5UKqd");

var $6mvtm = parcelRequire("6mvtm");

var $3t7DW = parcelRequire("3t7DW");

var $koI83 = parcelRequire("koI83");

var $Q2S5p = parcelRequire("Q2S5p");
const $c65106dab55c893f$var$pricingTitleInternal = (0, $koI83.getPricingTitleInternal)();
(0, $3t7DW.init)((0, $Q2S5p.JiraSoftwarePricingPage), (0, $5UKqd.PricingPageRelayQuery), (0, $5UKqd.getPricingPageRelayQueryVars)('jira-software', window.location, $c65106dab55c893f$var$pricingTitleInternal), (0, $6mvtm.RELAY_API_CONTENTFUL));


//# sourceMappingURL=jira-software-pricing-page.81d296e3.js.map
